import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Circle, ElementEventClick, Stroke } from '../../types';

@Component({
  selector: 'g[svg-circle]',
  templateUrl: './svgcircle.component.html',
  styleUrls: ['./svgcircle.component.css']
})
export class SvgCircleComponent implements OnInit {


  constructor() { }


  @Input()
  public circle: Circle;

  @Output()
  public circleMousedown = new EventEmitter<{ mouseEvent: MouseEvent, circle: Circle }>();
  @Output()
  public circleMouseover = new EventEmitter<{ mouseEvent: MouseEvent, circle: Circle }>();


  ngOnInit() {
    if (!this.circle.stroke) {
      this.circle.stroke = new Stroke();
    }
  }

  public onCircleMouseDown($event) {
    if ($event) {
      this.circleMousedown.emit({ mouseEvent: $event, circle: this.circle });
    }
  }

  public onCircleMouseOver($event) {
    if ($event) {
      this.circleMouseover.emit({ mouseEvent: $event, circle: this.circle });
    }
  }
}
